import { render } from "./refresh-button.vue?vue&type=template&id=a6bae210"
import script from "./refresh-button.vue?vue&type=script&lang=js"
export * from "./refresh-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__